<div id="logo" class="flex">
    <img src="./../../assets/trakrCounting_white.svg" class="mx-auto w-[60%] sm:w-[45%] md:w-[45%] lg:w-[45%]" class="mx-auto logo"/>
</div>